export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err: any, instance, info) => {
    console.error('Ошибка Vue:', err?.stack || err); // Вывод полного стектрейса
    console.log('Информация:', info); // Дополнительный контекст
  };
});